import type { CSSProperties } from "react"

import styles from "./CustomerCallsSection.module.scss"

export const CustomerCallsOutcomeDonut = ({ answeredPercent }: { answeredPercent: number }) => (
  <div
    className={styles.donut}
    role="img"
    aria-label={`${answeredPercent}% answered`}
    style={{ "--answered-percent": `${answeredPercent}%` } as CSSProperties}
  >
    <span className={styles.donutValue}>
      {answeredPercent}%<small>ANSWERED</small>
    </span>
  </div>
)
